import { ContentSection, DataOverview, DescriptionList } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { ContactOptionEnum } from "../../interfaces";

export const PersonalData = () => {
    const { t } = useTranslation(["summarypage", "personalinformation"]);
    const { goToPersonalDataStep, submitAnswersRequest } = useMatchMakerWizard();
    const { contactDetails: personalData } = submitAnswersRequest;

    return (
        <ContentSection.ComponentWrapper>
            <DataOverview
                href=""
                title={t("summarypage:personal-data.title", {
                    brand: process.env.REACT_APP_WEBSITE_BRAND?.toUpperCase(),
                })}
                buttonLabel={t("summarypage:edit")}
                buttonProps={{
                    id: "PersonalDataSummaryEditButton",
                    onClick: (e) => {
                        e.preventDefault();
                        goToPersonalDataStep(true);
                    },
                    tabIndex: 0,
                }}
                id="PersonalDataSummary"
            >
                <DescriptionList grid>
                    <DescriptionList.Group termText={t("summarypage:personal-data.name")}>
                        <DescriptionList.Detail id="PersonalDataName">
                            {personalData && personalData.firstName + " " + personalData.lastName}
                        </DescriptionList.Detail>
                    </DescriptionList.Group>
                    <DescriptionList.Group termText={t("summarypage:personal-data.phone")}>
                        <DescriptionList.Detail id="PersonalDataPhone">
                            {personalData && personalData.mobilePhoneCountryCode + " " + personalData.mobilePhoneNumber}
                        </DescriptionList.Detail>
                    </DescriptionList.Group>
                    <DescriptionList.Group termText={t("summarypage:personal-data.email")}>
                        <DescriptionList.Detail id="PersonalDataEmail">
                            {personalData && personalData.email}
                        </DescriptionList.Detail>
                    </DescriptionList.Group>
                    <DescriptionList.Group termText={t("summarypage:personal-data.prefered-contact-option")}>
                        <DescriptionList.Detail id="PersonalDataPreferedContactOption">
                            {personalData &&
                                (personalData.contactPreference === ContactOptionEnum.Email
                                    ? t("personalinformation:comunication-section.radio-email")
                                    : t("personalinformation:comunication-section.radio-phone-number"))}
                        </DescriptionList.Detail>
                    </DescriptionList.Group>
                </DescriptionList>
            </DataOverview>
        </ContentSection.ComponentWrapper>
    );
};
